import type { JsonValue } from "@bufbuild/protobuf";

const ARRAY_STRING_SEPARATOR = ", ";

function nonEmptyTrimmedStrings(values: JsonValue[]): string[] {
	return values.map(value => (typeof value === "string" ? value.trim() : "")).filter(value => value !== "");
}

export function arrayFromArrayValue(arrayValue: JsonValue | undefined): string[] {
	if (!Array.isArray(arrayValue)) {
		return [];
	}
	return nonEmptyTrimmedStrings(arrayValue.filter((item): item is string => typeof item === "string"));
}

export function arrayToArrayValue(array: JsonValue[]): string[] | undefined {
	const arrayValue = nonEmptyTrimmedStrings(array);
	if (arrayValue.length === 0) {
		return undefined;
	}
	return arrayValue;
}

export function formattedArray(value?: JsonValue): string {
	return arrayFromArrayValue(value).join(ARRAY_STRING_SEPARATOR);
}
